import { render } from "./FoodEventModal.vue?vue&type=template&id=0f3a7e4a&scoped=true"
import script from "./FoodEventModal.vue?vue&type=script&lang=js"
export * from "./FoodEventModal.vue?vue&type=script&lang=js"

import "./FoodEventModal.vue?vue&type=style&index=0&id=0f3a7e4a&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3a7e4a"]])

export default __exports__